import Link from "next/link";
import { Nav } from "react-bootstrap";
import { useCheckYOffset } from "../../utils/common";
import dynamic from "next/dynamic";

const ThemeChanger = dynamic(() => import('../../layout/common/themeChange'))

const HeaderMobileBottom = ({ onMobileMenu }) => {
	const contactUsClass = useCheckYOffset(80, "", ">");
	return (
		<Nav>
			<div className="nav-bottom-btn">
				<Link
					// href="/hire-dedicated-developers"
					href="/request-proposal"
					className={`btn btn-primary nav-link nav-mb-link-show  ${contactUsClass}`}
					onClick={onMobileMenu}
				>
					Contact Us
				</Link>
			</div>
			<div className="theme-div">
				<ThemeChanger />
			</div>
			<div className="submenu-bottom-content d-none-desktop d-none">
				<p>Are you a developer looking for a job? </p>
				<Link
					aria-label="careers"
					className="btn btn-primary"
					href="/careers"
				>
					See Opening
				</Link>
			</div>
		</Nav>
	);
};

export default HeaderMobileBottom;

